import { Component, OnInit } from '@angular/core';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexLegend, ApexPlotOptions, ApexXAxis, ApexYAxis } from 'ng-apexcharts';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { SUBSCRIPTIONCHARTDATA } from 'src/app/helpers/helperResources';
import { CurrencyService } from 'src/app/services/currency.service';
import { GeneralService } from 'src/app/services/general.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import DateUtils from 'src/app/utils/date';
import { ReportCurrencyFormatter } from 'src/app/models/reportCurrencyFormatter';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  colors: string[];
  legend: ApexLegend;
};

@Component({
  selector: 'app-subscription-report',
  templateUrl: './subscription-report.component.html',
  styleUrls: ['./subscription-report.component.css']
})
export class SubscriptionReportComponent implements OnInit {
  dateUtil = new DateUtils;
  public chart_labelsMonth = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  public chart_labelsQuater = ["Q1", "Q2", "Q3", "Q4"];
  public chartOptions: Partial<ChartOptions> = {
    series: [
      {
        name: "Active",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: "Due",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: "Suspended",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: "Terminated",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
    ],
    chart: {
      type: "bar",
      height: 270
    },
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
        // columnWidth: '30%',
      }
    },
    colors: ["rgb(27, 195, 27)", "rgb(21, 141, 237)", "rgb(128,128,128)", "rgb(255, 0, 0)"], // , , "rgb(0,0,205)",
    dataLabels: {
      enabled: false
    },
    legend: {
      show: true,
      position: 'bottom',
    }
  };

  dataTableSub = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
      // { title: "checkbox", key: "checkbox" },
      { title: "Month", key: "month" },
      { title: "Active", key: "active" },
      { title: "Due", key: "due" },
      { title: "Suspended", key: "suspended" },
      { title: "Terminated", key: "terminated" },
    ],
    rows: [],
    options: {
      datePipe: {},
      singleActions: [],
      bulkActions: [],
      noOfRowsToDisplay: 5
    },
  };

  dataSource: any;
  baseCurrency;
  selectedUserDetails;
  teamID;
  userId;
  cOptions: Partial<ChartOptions>;
  ViewSwitch = "Chart";
  selectedType = 'selfteam';
  viewType = 'month';
  loadingChart = false;
  years;
  barChartYear = new Date().getFullYear();
  format = 'amount';

  constructor(
    private subSvc: SubscriptionService,
    private currencySvc: CurrencyService,
    private gs: GeneralService,
    private performanceSvc: PerformanceReportService,
  ) {
    this.years = this.dateUtil.getYears();
    this.cOptions = {
      series: [
        {
          name: "Active",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "Due",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "Suspended",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "Terminated",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
      ],
      xaxis: {
        categories: [...this.chart_labelsMonth],
        title: {
          text: 'Subscription',
        },
      },
      yaxis: {
        title: {
          text: `Value in Base Currency`,
        },
      }
    }
    this.userId = this.gs.user.id;
    this.currencySvc.org_currencies.subscribe((org_currencies: any) => {
      this.baseCurrency = org_currencies.base_currency;
    });
  }

  ngOnInit() {
    this.setView();
  }

  private getAllSubscriptionOverview() {
    this.loadingChart = false;
    this.performanceSvc.selected_users.subscribe((res) => {
      this.selectedUserDetails = res;
      if (res.length !== 0) {
        const { ids, type } = res;
        let query;
        if (type === 'salesperson') {
          query = `${this.getDateFilterRange}&owner=${ids.toString()}`
        } else {
          query = `${this.getDateFilterRange}&teamId=${ids.toString()}`
        }
        this.subSvc
          .getSubscriptionByFilter(query)
          .pipe(take(1))
          .subscribe(
            (res: any) => {
              if (res) {
                this.dataSource = res.payload;
                this.loadingChart = true;

                let dataSourceInBaseCurr = this.currencySvc.dataSourceInBase(this.dataSource);
                // Get Data
                let data: any = {};
                data = SUBSCRIPTIONCHARTDATA(
                  dataSourceInBaseCurr,
                  this.format,
                  this.viewType
                );
                // Set DataTable Metrics
                this.handleDataTable(data);

                // Set Chart Data
                this.handleChartData(data)
              }
              else {
                this.loadingChart = true;
                this.cOptions.series = [
                  {
                    name: "Active",
                    data: []
                  },
                  {
                    name: "Due",
                    data: []
                  },
                  {
                    name: "Suspended",
                    data: []
                  },
                  {
                    name: "Terminated",
                    data: []
                  },
                ];
              }
            },
            (error) => {
            }
          );

      }
    });
  }

  private handleChartData(data) {
    if (this.format === 'amount') {
      this.cOptions.yaxis = {
        title: {
          text: `Value in Base Currency ${this.baseCurrency}`,
        },
        labels: {
          formatter: function (value) {
            const currencyF = new ReportCurrencyFormatter();
            return currencyF.handleFormatter(value)
            // value.toLocaleString("en-US", { style: "currency", currency: "USD" });
            // value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        },
      }
    } else {
      this.cOptions.yaxis = {
        title: {
          text: `Value in Numbers`,
        }
      }
    }

    this.cOptions.series = [{
      name: "Active",
      data: [...data.active]
    }, {
      name: "Due",
      data: [...data.due]
    }, {
      name: "Suspended",
      data: [...data.suspended]
    }, {
      name: "Terminated",
      data: [...data.terminated]
    }
    ];
  }

  private handleDataTable(data) {
    let i = 0;
    let row = [];
    if (this.viewType === 'month') {
      while (i < 12) {
        row.push({
          month: this.chart_labelsMonth[i],
          terminated: this.format === 'amount' ? data.terminated[i].toFixed(2) : data.terminated[i],
          due: this.format === 'amount' ? data.due[i].toFixed(2) : data.due[i],
          active: this.format === 'amount' ? data.active[i].toFixed(2) : data.active[i],
          suspended: this.format === 'amount' ? data.suspended[i].toFixed(2) : data.suspended[i]
        });
        i++;
      }
    }
    else {
      while (i < 4) {
        row.push({
          month: this.chart_labelsQuater[i],
          terminated: this.format === 'amount' ? data.terminated[i].toFixed(2) : data.terminated[i],
          due: this.format === 'amount' ? data.due[i].toFixed(2) : data.due[i],
          active: this.format === 'amount' ? data.active[i].toFixed(2) : data.active[i],
          suspended: this.format === 'amount' ? data.suspended[i].toFixed(2) : data.suspended[i]
        });
        i++;
      }
    }
    this.dataTableSub.rows = row;
    this.dataTableSub.dataChangedObs.next(true);
  }

  // Get Date Filter
  private get getDateFilterRange() {
    const startYr = Date.parse(
      new Date(`01/01/${this.barChartYear}`).toISOString()
    );
    const endYr = new Date(Date.parse(`12/31/${this.barChartYear}`)).setHours(23, 59, 59, 59);
    const jsonValueRange = {
      createdOn: { from: startYr, to: endYr },
    };
    return `range=${JSON.stringify(jsonValueRange)}`;
  }

  setView() {
    if (this.viewType === 'month') {
      this.cOptions.xaxis = {
        categories: [...this.chart_labelsMonth],
        title: {
          text: 'Subscriptions',
        },
      }
    } else if (this.viewType === 'quarter') {
      this.cOptions.xaxis = {
        categories: [...this.chart_labelsQuater],
        title: {
          text: 'Subscriptions',
        },
      }
    }
    this.getAllSubscriptionOverview();

  }

  handleViewSwitch(view) {
    this.ViewSwitch = view;
  }

}
